var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.138 2.25C6.6855 2.25 2.25 6.6855 2.25 12.138C2.25 17.5905 6.6855 22.0252 12.138 22.0252C17.5905 22.0252 22.0252 17.5905 22.0252 12.138C22.0252 6.6855 17.5897 2.25 12.138 2.25ZM12.138 20.2507C7.665 20.2507 4.026 16.611 4.026 12.138C4.026 7.665 7.665 4.026 12.138 4.026C16.6117 4.026 20.2507 7.665 20.2507 12.138C20.2507 16.611 16.611 20.2507 12.138 20.2507Z",
    fill: "#F0F3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7995 7.5L11.25 7.5L11.25 14.0497L12.7995 14.0498L12.7995 7.5Z",
    fill: "#F0F3F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7995 15.5L11.25 15.5L11.25 17.0487L12.7995 17.0487L12.7995 15.5Z",
    fill: "#F0F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoCircleWhite);
export default __webpack_public_path__ + "static/media/icon-info-circle-white.3d0af0bd475f6bea004e9b81734128f6.svg";
export { ForwardRef as ReactComponent };